/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { ApplicationRef, ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { OSKErrorService } from './error.service';

@Injectable()
export class OSKGlobalErrorHandler extends ErrorHandler {
  private readonly errorService: OSKErrorService = inject(OSKErrorService);
  private readonly zone: NgZone = inject(NgZone);
  private readonly injector: Injector = inject(Injector);
  private readonly handledErrors = new WeakSet<object>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override handleError(error: any): void {
    if (error && typeof error === 'object') {
      if (this.handledErrors.has(error)) {
        return;
      }
      this.handledErrors.add(error);
      if (error.rejection && typeof error.rejection === 'object') {
        if (this.handledErrors.has(error.rejection)) {
          return;
        }
        this.handledErrors.add(error.rejection);
      }
    }

    const originalError = error?.rejection ?? error?.ngOriginalError ?? error;
    const message: string | undefined = originalError?.message ?? error?.message;
    this.notifyError(message);
    console.error(error);
  }

  private notifyError(message?: string): void {
    this.zone.run(() => {
      this.errorService.showError(message);
      queueMicrotask(() => {
        try {
          this.injector.get(ApplicationRef).tick();
        } catch {
          // Ignore if ApplicationRef is not yet initialized
        }
      });
    });
  }
}
